import { Routes as ReactRoutes, Route } from "react-router-dom"; // Updated import
import { useAppBridge } from "@shopify/app-bridge-react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Product from "../Components/Product";
import Order from "../Components/Order";
import Account from "../Components/account/account";
import withNavigation from "../services/withNavigation";
import { Redirect } from "@shopify/app-bridge/actions";
import { createApp } from "@shopify/app-bridge";

function ShopifyRouteSync() {
  const location = useLocation();
  const searchParams = window.location.search;
  const urlSearchParams = new URLSearchParams(searchParams);
  let query = Object.fromEntries(urlSearchParams.entries());

  const app = createApp({
    apiKey: process.env.REACT_APP_API_KEY,
    host: query.host
  });

  useEffect(() => {
    if (app) {
      app.dispatch(
        Redirect.toRemote({
          url: location.pathname,
          host: query.host,
        })
      );
    }
  }, [location, app]);

  return null;
}

function Routes(props) {
  const isAccepted = props.userConfig.sellerStatus === "Accepted";
  const isLoggedIn = isAccepted;

  return (
    <>
      <ShopifyRouteSync /> {/* New component to sync routes with Shopify */}
      <ReactRoutes>
        {isLoggedIn ? (
          <>
            <Route path="/products" element={<Product />} />
            <Route path="/orders" element={<Order />} />
            <Route path="/account" element={<Account />} />
            <Route path="/" element={<Account />} />
          </>
        ) : (
          <>
            <Route path="/account" element={<Account />} />
            <Route path="/" element={<Account />} />
          </>
        )}
      </ReactRoutes>
    </>
  );
}

export default withNavigation(Routes);